import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
  return (
    <div className='footer-view flex-row center'>
      <div className='footer-text'>
        {'\u00A9'} Urbanresearch.site | <Link to="/about">About</Link>
      </div>
    </div>
  )
}

export default Footer